module.exports = __webpack_public_path__ + "media/images/payment_methods/bancontact-921db2e724e286b2658ba84b705d4f48.svg";